<template>
  <div class="mobile-nav-list">
    <ul class="nav-root">
      <li class="nav-logo-item">
        <router-link to="/">
          <svg viewBox="0 0 48 45" height="20" width="20" fill="#F56368" style="vertical-align: middle; margin-right: 8px;">
            <path d="M30.7,19.5c0-2.3-1.8-4.1-4.1-4.1H11.7C5.2,15.4,0,20.7,0,27.2v13.8C0,43.2,1.8,45,4.1,45s4.1-1.8,4.1-4.1V27.2c0-1.9,1.6-3.5,3.5-3.5h14.9c2.3,0,4.1-1.8,4.1-4.2z"/>
            <path d="M28.8,0H4.2C1.8,0,0,1.8,0,4.1s1.8,4.1,4.1,4.1h24.5c6.1,0,11.1,5,11.1,11.1s-5,11.1-11.1,11.1h-10c-2.3,0-4.1,1.8-4.1,4.1s1.8,4.1,4.1,4.1h10C39.4,38.6,48,30,48,19.3S39.4,0,28.8,0z"/>
          </svg>
          <span>{{$t('header.navHome')}}</span>
        </router-link>
      </li>
      <template v-if="!user.uid">
        <li>
          <router-link to="/products?type=diarybook">{{$t('header.navProduct')}}</router-link>
        </li>
        <li>
          <router-link to="/reviews">{{$t('header.navReviews')}}</router-link>
        </li>
        <li>
          <a href="/2.0/#home-faq">{{$t('header.navFAQ')}}</a>
        </li>
        <li>
          <a href="/2.0/products?type=diarybook#pricing">{{$t('header.navPricing')}}</a>
        </li>
      </template>
      <template v-else>
        <li>
          <router-link to="/app/shelf">{{$t('header.navShelf')}}</router-link>
        </li>
        <li>
          <router-link to="/app/orders">{{$t('header.navOrder')}}</router-link>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: '',
  data () {
    return {}
  },
  computed: {
    ...mapGetters([
      'user'
    ])
  },
  created () {}
}
</script>

<style lang="scss">
@import '../../styles/layout/NavList.scss';
</style>
